import React, { useRef, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useReactToPrint } from "react-to-print";
import { useCombinedContext } from "../../context/CombinedContext";
import logo from "../../assets/WHL-LOGO.png";
import axiosInstance from "../../services/auth";
import LoanRepayment from "./LoanRepayment";
import "./Loan.css";

const LoanPaymentReport = ({
  loan,
  onClose,
  formatPrice,
  companyCode,
  companyId,
  employee,
  fetchLoan,
}) => {
  const [editTarget, setEditTarget] = useState(null);
  const [editAmount, setEditAmount] = useState("");
  const [editDate, setEditDate] = useState("");
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [localLoan, setLocalLoan] = useState(loan);
  const [showPaymentForm, setShowPaymentForm] = useState(false);

  const printRef = useRef(null);
  const { selectedCompany } = useCombinedContext();
  const company = selectedCompany;
  console.log(loan);
  useEffect(() => {
    setLocalLoan(loan);
  }, [loan]);

  const handleAddClick = () => {
    setShowPaymentForm(true);
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const handleEditClick = (repayment) => {
    setEditTarget(repayment);
    setEditAmount(repayment.amount);
    setEditDate(new Date(repayment.date).toISOString().split("T")[0]);
  };

  const confirmEdit = async () => {
    try {
      const body = {
        amount: parseFloat(editAmount),
        date: editDate,
      };
      await axiosInstance.patch(
        `/loan/repayment/${loan._id}/update/${editTarget._id}`,
        body,
      );
      toast.success("Repayment updated!");

      // Update local state
      setLocalLoan((prev) => {
        const updatedTransactions = prev.repaymentTransactions.map((txn) =>
          txn._id === editTarget._id ? { ...txn, ...body } : txn,
        );
        const updatedTotal = updatedTransactions.reduce(
          (acc, cur) => acc + parseFloat(cur.amount || 0),
          0,
        );
        return {
          ...prev,
          repaymentTransactions: updatedTransactions,
          totalRepaymentAmount: updatedTotal,
          balanceAmount: prev.totalLoanAmount - updatedTotal,
        };
      });

      setEditTarget(null);
    } catch (error) {
      toast.error("Failed to update repayment.");
    }
  };

  const confirmDelete = async () => {
    try {
      await axiosInstance.delete(
        `/loan/repayment/${loan.employee?._id}/${deleteTarget}`,
      );
      toast.success("Repayment deleted successfully!");

      setLocalLoan((prev) => {
        const updatedTransactions = prev.repaymentTransactions.filter(
          (txn) => txn._id !== deleteTarget,
        );
        const updatedTotal = updatedTransactions.reduce(
          (acc, cur) => acc + parseFloat(cur.amount || 0),
          0,
        );
        return {
          ...prev,
          repaymentTransactions: updatedTransactions,
          totalRepaymentAmount: updatedTotal,
          balanceAmount: prev.totalLoanAmount - updatedTotal,
        };
      });

      setIsDeleteModalOpen(false);
      setDeleteTarget(null);
    } catch (error) {
      toast.error("Failed to delete repayment.");
    }
  };

  const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));
  const userRole = authData.role;
  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) onClose();
        }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content foodallowance_model">
            <div className="modal-header text-white text-center vesel_form">
              <h5 className="modal-title">Loan Payment Report</h5>
              <button
                type="button"
                className="btn-close text-white"
                onClick={onClose}
              ></button>
            </div>
            <div ref={printRef} className="modal-body modalWhite">
              <div className="food_head mb-3 d-flex">
                <img
                  src={logo}
                  alt="logo"
                  style={{ width: "125px", paddingRight: "20px" }}
                />
                <div style={{ flex: 1 }}>
                  <h2
                    className="company_font"
                    style={{ margin: 0, textDecoration: "underline" }}
                  >
                    {company.company_name}
                  </h2>
                  <p style={{ margin: 0, fontSize: "12px" }}>
                    {`Co Reg No: ${company.co_regno} GST No: ${company.gst_no}`}
                    <br />
                    {company.address}
                    <br />
                    {`Tel: ${company.telephone} Fax: ${company.fax}`}
                    <br />
                    {company.email}
                  </p>
                </div>
              </div>
              <hr />
              <p>
                <strong>Employee Name:</strong> {localLoan.employee?.name}
              </p>
              <p>
                <strong>Employee ID No:</strong>{" "}
                {localLoan.employee?.employeeNo}
              </p>
              <div className="d-flex px-5">
                <button
                  className="button-2 ms-auto for_print"
                  onClick={handleAddClick}
                >
                  Add Payment
                </button>
              </div>
              <table className="table mt-4">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th className="text-center">Amount</th>
                    {["superadmin"].includes(userRole) && (
                      <th className="text-center for_print">Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {localLoan?.repaymentTransactions?.length > 0 ? (
                    localLoan.repaymentTransactions.map((detail) => (
                      <tr key={detail._id}>
                        <td>{new Date(detail.date).toLocaleDateString()}</td>
                        <td className="text-center">
                          ${formatPrice(detail.amount)}
                        </td>
                        {["superadmin"].includes(userRole) && (
                          <td className="text-center for_print">
                            <button
                              className="btn btn-outline-success btn-sm me-2"
                              onClick={() => handleEditClick(detail)}
                            >
                              <i className="bi bi-pencil-square"></i>
                            </button>
                            <button
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => {
                                setDeleteTarget(detail._id);
                                setIsDeleteModalOpen(true);
                              }}
                            >
                              <i className="bi bi-trash3"></i>
                            </button>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No repayment found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <p>
                <strong>Total Loan Amount:</strong> $
                {formatPrice(localLoan.totalLoanAmount)}
              </p>
              <p>
                <strong>Total Paid:</strong> $
                {formatPrice(localLoan.totalRepaymentAmount)}
              </p>
              <p>
                <strong>Balance Amount:</strong> $
                {localLoan.balanceAmount.toFixed(2)}
              </p>
            </div>
            <div className="text-center">
              <button className="button-2 mb-4" onClick={handlePrint}>
                Print
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      {isDeleteModalOpen && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          tabIndex="-1"
          onClick={(e) => {
            if (e.target.classList.contains("modal"))
              setIsDeleteModalOpen(false);
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Deletion</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setIsDeleteModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                Are you sure you want to delete this repayment? This action
                cannot be undone.
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setIsDeleteModalOpen(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={confirmDelete}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editTarget && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          tabIndex="-1"
          onClick={(e) => {
            if (e.target.classList.contains("modal")) setEditTarget(null);
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Repayment</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditTarget(null)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editAmount}
                    onChange={(e) => setEditAmount(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={editDate}
                    onChange={(e) => setEditDate(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setEditTarget(null)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={confirmEdit}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showPaymentForm && (
        <LoanRepayment
          loan={loan}
          companyCode={companyCode}
          companyId={companyId}
          formatPrice={formatPrice}
          employee={employee}
          selectedCompany={selectedCompany}
          onClose={() => {
            setShowPaymentForm(false);
            fetchLoan();
          }}
        />
      )}
    </>
  );
};

export default LoanPaymentReport;
